import { STORE_REQUEST_METADATA, STORE_REQUEST_ORIGIN } from 'apps/http/actions/http';

export const initialState = {
  referrer: '',
  currentRoute: '',
  previousRoute: '',
  origin: '',
};

export default function http(state = initialState, action) {
  switch (action.type) {
    case STORE_REQUEST_ORIGIN: {
      const { origin } = action;
      return { ...state, origin };
    }
    case STORE_REQUEST_METADATA: {
      const { referrer, origin, currentRoute, previousRoute, query } = action;
      return { ...state, referrer, origin, currentRoute, previousRoute, query };
    }
    default:
      return state;
  }
}
